export default __webpack_public_path__ + "static/media/section1.1114346b.svg";